import { TReduxStore } from '../types';

export function assertStore(store: TReduxStore | undefined) {
  if (!store) {
    throw new Error(
      '[MessageEventManager] messageEventManager must be initialized first. Forgot to call init() before accessing messageEventManager?',
    );
  }
}
